import BaseView from '../../../js/base-view';

const TIMEOUT_AFTER_SUCCESS = 3000;
const CLASS_PROCESSING = 'is-processing';
const CLASS_SUCCESS = 'is-success';
const CLASS_ERROR = 'is-error';

const STATE_IDLE = 'idle';
const STATE_PROCESSING = 'processing';
const STATE_SUCCESS = 'success';
const STATE_ERROR = 'error';

/**
 * Re-implementation of WooCommerce add-to-cart script
 *
 * @see https://github.com/woocommerce/woocommerce/blob/4.2.2/assets/js/frontend/add-to-cart.js
 */
export default class AddToCart extends BaseView {
	init() {
		if (! window.supt || ! window.supt.addToCart) {
			console.error('Could not load "addToCart" params');
			return false;
		}

		this.config = window.supt.addToCart;

		this.props = {
			isSingle: (this.el.hasAttribute('type') && this.el.getAttribute('type') === 'submit'),
		};

		if (this.props.isSingle) {
			this.refs = {
				form: this.el.closest('form'),
			};

			this.config.endpoint = this.refs.form.getAttribute('action');
		}

		this.state = {
			status: STATE_IDLE
		};

		this.on('click', this.onClick.bind(this));

		this.onSuccess = this.onSuccess.bind(this);
		this.onError = this.onError.bind(this);

		return this;
	}

	setState(newState = {}) {
		/* eslint-disable default-case */

		Object.keys(newState)
			.forEach((key) => {
				this.state[key] = newState[key];

				switch (key) {
					case 'status':
						this.updateDOM();
						break;
				}

			});


		return true;
	}

	onClick(event) {
		event.preventDefault();

		if (this.state.status !== STATE_IDLE) return;
		this.setState({ status: STATE_PROCESSING });

		if (this.props.isSingle) this.singleToCart();
		else this.cardToCart();
	}

	onSuccess() {
		this.setState({ status: STATE_SUCCESS });
		this.trigger('added-to-cart');

		setTimeout(() => {
			this.setState({ status: STATE_IDLE });
		}, TIMEOUT_AFTER_SUCCESS);
	}

	onError() {
		this.setState({ status: STATE_ERROR });
		console.error('Unable to add to cart');
	}

	singleToCart() {
		const data = new FormData(this.el.closest('form'));
		this.addToCart(data)
			.then(this.onSuccess)
			.catch(this.onError);
	}

	cardToCart() {
		const data = new FormData();
		data.append('quantity', this.el.dataset.quantity);
		data.append('add-to-cart', this.el.dataset.productId);
		this.addToCart(data)
			.then(this.onSuccess)
			.catch(this.onError);
	}

	addToCart(data) {
		return new Promise((resolve, reject) => {
			if (!data) reject();

			window.fetch(this.config.endpoint, {
				method: 'POST',
				credentials: 'same-origin',
				body: data,
			})
				.then(resolve);
		});
	}

	updateDOM() {
		const removeClasses = [];
		const addClasses = [];

		switch (this.state.status) {
			case STATE_PROCESSING:
				addClasses.push(CLASS_PROCESSING);
				break;

			case STATE_SUCCESS:
				addClasses.push(CLASS_SUCCESS);
				removeClasses.push(CLASS_PROCESSING);
				this.el.innerHTML = this.config.i18n_added;
				break;

			case STATE_ERROR:
				addClasses.push(CLASS_ERROR);
				removeClasses.push(CLASS_PROCESSING);
				break;

			case STATE_IDLE:
			default:
				this.el.textContent = this.config.i18n_add_to_cart;
				removeClasses.push(CLASS_SUCCESS, CLASS_ERROR, CLASS_PROCESSING);
				break;
		}

		addClasses.forEach(cls => this.el.classList.add(cls));
		removeClasses.forEach(cls => this.el.classList.remove(cls));
	}
}
